import i18n from '@/i18n/i18n'
import { RelatedPostService } from '@/services/admin/RelatedPostService'
import { errorMessage } from '@/utilities/helpers.js'

const relatedPostService = new RelatedPostService()

const { t } = i18n.global

export const namespaced = true

export const state = {
  relatedPosts: []
}

export const mutations = {
  SET_RELATED_POSTS(state, relatedPosts) {
    state.relatedPosts = relatedPosts.data
  },
  ADD_RELATED_POST(state, relatedPost) {
    state.relatedPosts.push(relatedPost)
  },
  DELETE_RELATED_POST(state, relatedPostToRemove) {
    state.relatedPosts = state.relatedPosts.filter(relatedPost => {
      return relatedPost.id !== relatedPostToRemove.id
    })
  }
}

export const actions = {
  getRelatedPosts({ commit }, post) {
    return new Promise(resolve => {
      relatedPostService.getRelatedPosts(post).then(response => {
        commit('SET_RELATED_POSTS', response)
        resolve(response.data)
      })
    })
  },
  createRelatedPost({ _, dispatch }, data) {
    return new Promise((resolve, reject) => {
      relatedPostService
        .createRelatedPost(data.post, { related_posts: data.related_posts })
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.added', {
              element: t('store.admin.relatedPost.featured_article')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateRelatedPost({ _, dispatch }, data) {
    return new Promise((resolve, reject) => {
      relatedPostService
        .updateRelatedPost(data.post, { related_posts: data.related_posts })
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.relatedPost.featured_article')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteRelatedPost({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      relatedPostService
        .deleteRelatedPost(data.post, data.relatedPost)
        .then(response => {
          commit('DELETE_RELATED_POST', response.data)
          const notification = {
            type: 'warning',
            message: t('store.shared.deleted', {
              element: t('store.admin.relatedPost.featured_article')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
